<template>
  <div class="sion-personnel" v-loading.fullscreen.lock="loading">
    <div class="sino-panel">
      <!-- 搜索框 -->
      <div class="panel-top">
        <el-input v-model="seach">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <div class="search-btn" @click="search">搜索</div>
      </div>
      <!-- 搜索框结束 -->
      <div class="panel-content">
        <template>
          <div class="panel-scroll">
            <!-- 左侧科室盒子 -->
            <div class="scroll-aside">
              <div
                :class="['aside-item',item.active?'item-active':'']"
                v-for="(item,index) in branchList"
                :key="index"
                @click="selectOffice(item,branchList,'branch')"
              >
                <span class="management-name">{{item.unionName}}</span>
                <span>({{item.cnt}})</span>
              </div>
            </div>
            <!-- 左侧科室盒子结束 -->
            <!-- 分会 -->
            <div class="scroll-aside">
              <div
                :class="['aside-item',item.active?'item-active':'']"
                v-for="(item,index) in departmentList"
                :key="index"
                @click="selectOffice(item,departmentList,'department')"
              >
                <span class="management-name">{{item.deptName}}</span>
                <span>({{item.cnt}})</span>
              </div>
            </div>
            <!-- 分会结束 -->
            <div class="scroll-panel" ref="scrollView">
              <!-- 选则人得盒子 -->
              <div class="item item-radio">
                <cube-checkbox-group v-model="checkList">
                  <cube-checkbox
                    v-for="(item, index) in staffListData"
                    :key="index"
                    :option="item"
                    v-model="selected"
                  >
                    <div class="panel-item">
                      
                      <div class="item item-info">
                        <div @click="getPersonDetail(item)">
                          <div class="item-container">
                            <div class="item item-phone">
                              <img v-if="item.photo" :src="item.photo" alt />
                              <img v-else src="@/images/doctor.png" alt srcset />
                            </div>
                             <div class="info-name">{{item.name}}</div>
                          </div>
                          <div class="info-number">性别:{{item.sex == "2" ? "女" : "男"}}</div>
                        </div>
                        <div class="info-number" @click="callTel(item.phone)">
                          手机号:
                          <span>{{item.phone}}</span>
                        </div>
                      </div>
                    </div>
                  </cube-checkbox>
                </cube-checkbox-group>
              </div>
              <!-- 选则人得盒子结束 -->

              <div
                class="load-more mr-bottom"
                v-if="currentData<staffListData.length"
                @click="loadMore"
              >点击加载更多</div>
              <div class="load-more mr-bottom" v-else>没有更多了</div>
            </div>
          </div>
        </template>
      </div>
      <div class="sino-footer">
        <div class="footer-box transfer" @click="selectOK">确定</div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
export default {
  data() {
    return {
      checkList: [],
      seach: "",
      loading: false,
      currentData: 20,
      branchList: [],
      departmentList:[],
      departmentObje:{},
      activeData: [],
      departmentFlag:"",//科室
      branchFlag:"",//分会
      staffListData: [],
      currentDepartment: "",
      unionId: JSON.parse(localStorage.getItem("loginInfo")).unionId,
      actionShow: false,
      option: {
        label: "",
      },
      sendType: this.$route.query.sendType,
      recordId: this.$route.query.recordId,
      id: this.$route.query.id,
      options: {},
      selected: "",
      selectedPerson: "",
    };
  },
  watch: {
    seach(value) {
      if (!value) {
        this.getAppStaffList(this.currentDepartment);
      }
    },
  },
  created() {
    //获取需要跳转得路由地址 并保存
    this.router = this.$route.query.router;
    this.getUnionAndDeptRepreTree();
    this.getAppStaffList();
    window.addEventListener("scroll", this.scrollBottom);
  
  },
  methods: {
    getUnionAndDeptRepreTree(){
       this.centralControl.axios.centralControl(
        "getUnionAndDeptRepreTree",
        (res) => {
          const { message, code, data } = res;
          if (code == 200) {
            this.branchList = data.unionList;
            this.departmentList = data.deptList;
            this.departmentObje = JSON.parse(JSON.stringify(data.deptList));
              this.selectOffice(this.branchList[0],this.branchList,'branch')
          } else {
            toast(this, message);
          }
        },
        { sendType:this.sendType}
      );
    },
    //点击确定事件 跳转到相对得路由 并保存存储得值
    selectOK() {
      console.log(this.checkList,"---");
      if (this.checkList.length == 0) {
        toast(this, "附议人员不能为空");
        return;
      }
      var obj = {
        id: this.recordId, //记录recordId
        proposalId: this.id, //提案ID
        staffIds: this.checkList.join(","), //人员ID
      };

      this.centralControl.axios.centralControl(
        "inviteSupportProposal",
        (res) => {
          const { message, code, data } = res;
          if (code == 200) {
            this.$router.go(-1);
          } else {
            toast(this, message);
          }
        },
        obj
      );
    },
    loadMore() {
      this.currentData += 20;
    },
    //后端发送请求函数
    sendQuestion(url, obj, fun) {
      this.centralControl.axios.centralControl(
        url,
        (res) => {
          const { message, code, data } = res;
          //请求返回 关闭加载页
          this.loading = false;
          if (code == 200) {
            this[fun](data, message);
          } else {
            console.log(res, "接口错误-");
          }
        },
        obj
      );
    },
    //获取人员回调
    getAppStaffListFun(data, message) {
      data.forEach((item) => {
        item.check = false;
        item.value = item.id;
      });
      this.staffListData = data;
      this.loading = false;
    },
    getAppStaffListData(item = {}) {
      item.name = this.seach;
      item.sendType = this.sendType;
      return item;
    },
    getAppStaffList(item) {
      var obj = this.getAppStaffListData(item);
      this.sendQuestion("personnelWechatRepreList", obj, "getAppStaffListFun");
    },
    selectOffice(item,arr,type) {
      this.currentData = 20;
      this.$refs.scrollView.scrollTop = 0;
      arr.forEach((item) => {
        item.active = false;
      });
      item.active = true;
      this[type](item);
      this.currentDepartment = item.id;
    },
    assignedDepartment(obj){
      this.departmentList = [];
      var item = {
          unionId: "",
          cnt:obj.cnt,
          active:true,
          deptName:"全部"
      }
      var arr = [];
      arr.push(item);
      for(var a =0;a<this.departmentObje.length;a++){
          if(this.departmentObje[a].unionId == obj.unionId || obj.unionId ==''){
            this.departmentObje[a].active = false;
            arr.push(this.departmentObje[a]);
          }
      }
      this.departmentList = arr;

    },
    branch(obj){
      //科室赋值器
      this.assignedDepartment(obj);
       var item = {
         unionId:obj.unionId
      }
      this.branchFlag = obj.unionId;//赋值分会
      this.departmentFlag = "";
       this.getAppStaffList(item);
    },
    department(obj){
      var item = {
        deptId:obj.deptId
      }
      this.departmentFlag = obj.deptId;
        this.getAppStaffList(item);
    },

    //模糊搜索
    search() {
       var item = {};
      if(this.departmentFlag!=''){
        item.deptId = this.departmentFlag;
      }else{
        item.unionId = this.branchFlag;
      }
      this.getAppStaffList(item);
    },
    callTel(tel) {
      if (!tel) return;
      let telNode = document.createElement("a");
      telNode.style.display = "none";
      telNode.href = "tel:" + tel;
      telNode.click();
    },
    getPersonDetail(option) {
      this.$router.push({
        path: "/persinnelDetail",
        query: {
          id: option.id,
        },
      });
    },
  },
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/common.styl';
>>> .cube-checkbox-label {
  margin-left: 0;
}
>>> .cube-checkbox-wrap {
  padding: 0 !important;
}
.el-message--success {
  background-color: #fff !important;
  border-color: #e2e2e2 !important;
}

.el-message {
  min-width: 100px !important;
  max-width: 80%;
}

.person {
  width: 80% !important;

  .person-block {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
  }

  > i.el-message, > i.el-icon-success {
    display: none;
  }

  p.title, p.success {
    color: #000 !important;
  }

  p.fail {
    color: red !important;
  }

  i {
    display: inline-block;
    margin-right: 5px;
  }

  .msg {
    margin-bottom: 10px;
  }
}

.mr-bottom {
  text-align: center;
  font-size: 14px;
  color: #38c7c4;
  padding: 10px 0;
}

.sino-footer {
  .election {
    flex: 5;

    
  }

  .transfer {
    flex: 2;
    background: rgba(56, 199, 196, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);

    &:active {
      background: rgba(56, 199, 196, 0.5);
    }
  }

  .footer-box {
    height: 100%;
  }
}

.panel-top {
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 0.6rem;

  .search-btn {
    width: 40px;
    margin-left: 0.5rem;
    color: #999;
    white-space: nowrap;
  }

  .el-input__inner {
    height: 32px;
    border-radius: 16px;
    background: rgba(239, 239, 244, 1);
  }

  .el-input__icon {
    line-height: 32px;
  }

  // input::-webkit-input-placeholder{
  // line-height: 32px !important;
  // }
  input {
    padding: 8px 0.8rem !important;
    height: 30px !important;
    font-size: 14px !important;
    line-height: 14px !important;
  }
}

.panel-content {
  height: calc(100vh - 60px - 59px);
  overflow-y: scroll;

  .panel-scroll {
    height: 100%;
    display: flex;

    .scroll-aside {
      height: 100%;
      overflow: auto;
      flex: 2;

      .aside-item {
        text-align: center;
        // height: 60px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .item-active {
        background: #ffffff !important;
        color: #38c7c4;
      }
    }

    .scroll-panel {
      flex: 5;
      height: 100%;
      overflow: auto;
      background: #fff;

      .panel-item {
        display: flex;
        height: 71px;
        padding: 0.15rem 0;
        background: #ffffff;
        justify-content: flex-start;
        align-items: center;
        margin-left: 10px;

        .item-radio {
          display: flex;
          align-items: center;
          width: 46px;
          .cube-checkbox {
            padding: 0 0 0 0.04rem;
          }
        }
        .item-container {
          display: flex;
          align-items: center;
        }
        .item-phone {
          display: flex;
          align-items: center;
          width: 20px;
          height: 20px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item-info {
          flex: 1;
          margin-left: 0.3rem;
          .info-name {
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(53, 53, 53, 1);
            max-width: 100px;
            width:132px;
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap; /* 不换行 */
            text-overflow: ellipsis; /* 超出部分文字以...显示 */
            ellipsis();
          }

          .info-number {
            height: 20px;
            line-height: 20px;
            color: rgba(153, 153, 153, 1);
            font-size: 13px;
          }
        }
      }
    }
  }
}

.cube-radio-wrap {
  .cube-radio-ui {
    font-size: 22px;
  }
}

.cube-action-sheet-list {
  height: 151px;
  overflow: auto;
  touch-action: auto;
}

.cube-action-sheet-space {
  height: 0.03rem;
}

.cube-action-sheet-title {
  background: rgba(232, 232, 241, 1);
  color: rgba(136, 136, 136, 1);
  height: 0.2rem;
  line-height: 0.2rem;
  font-size: 15px;
}

.management-name {
  display: inline-block;
  font-size: 14px;
  line-height: 18px;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  // overflow: hidden;
}
</style>